var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    _vm._l(_vm.upgradepromotions, function(alert) {
      return _c(
        "v-col",
        {
          key: alert.id,
          staticClass: "d-block pt-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-alert",
            {
              staticClass: "py-3 px-1 mb-0",
              attrs: {
                color: "primary",
                role: "note"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "prepend",
                    fn: function fn() {
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mx-2 d-none d-sm-block",
                            attrs: {
                              size: "24",
                              color: "#ffd859"
                            }
                          },
                          [_vm._v("mdi-star")]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex justify-space-between align-center"
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "text-white font-weight-bold"
                      },
                      [_vm._v(_vm._s(alert.name))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "text-white"
                      },
                      [_vm._v(_vm._s(alert.description))]
                    )
                  ]),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-md-2",
                      attrs: {
                        color: "primary",
                        elevation: "4",
                        to: {
                          name: "hosting_create_request",
                          params: {
                            path: alert.path,
                            hostingid: alert.service_id
                          }
                        },
                        role: "link"
                      }
                    },
                    [_vm._v(" View Promotion ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }